<div class="new-client-container">
    <h4>New Client</h4>
    <div class="Vert-30"></div>

    <form [formGroup]="clientForm">
        <div class="row">
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>First Name</mat-label>
                    <input type="text" matInput formControlName="firstName">
                    <mat-error *ngIf="clientForm.controls.firstName.errors?.required">First
                        name
                        is required</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Last Name</mat-label>
                    <input type="text" matInput formControlName="lastName">
                    <mat-error *ngIf="clientForm.controls.lastName.errors?.required">Last name
                        is
                        required</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Email</mat-label>
                    <input type="text" matInput formControlName="email">
                    <mat-error *ngIf="clientForm.controls.email.errors?.required">Email
                        is required</mat-error>
                    <mat-error *ngIf="!clientForm.controls.email.errors?.required && clientForm.controls.email.invalid">
                        Email
                        format is incorrect</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12">
                <mat-form-field appearance="outline" floatLabel="always">
                    <mat-label>Phone</mat-label>
                    <input type="text" matInput formControlName="mobilePhone" matInputPhoneNumber>
                </mat-form-field>
            </div>
        </div>

        <div class="buttons float-end">
            <button mat-button class="btn btn-secondary float-end" (click)="dialogRef.close(false)">Cancel</button>
            <button mat-button class="btn btn-primary float-end" [disabled]="!clientForm.valid" (click)="saveClient()">Save</button>
        </div>
    </form>
</div>